var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"prose prose-puple container mx-auto wysiwyg py-12 px-8 lg:px-24",domProps:{"innerHTML":_vm._s(_vm.devise.copy.text)}})}
var staticRenderFns = []

export { render, staticRenderFns }